export default __webpack_public_path__ + "8c9600cc7859a6afeb8f9cd3608902f2.png";